// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

// ==================Dependance===================
import {
  Backdrop,
  Box, Fade, Modal, Typography,
} from '@mui/material';

// =================React Hooks==================
import { useDispatch, useSelector } from 'react-redux';
// import { useEffect } from 'react';

// =================Lib==================
import DOMPurify from 'dompurify';

// =============Actions=====================
import { setOpenBackendModal } from '../../actions/site';

// ==========static Style Modal=============
const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  bgcolor: 'background.paper',
  border: '1px solid grey',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
};

function BackendPopup() {
  // ===============HOOKS===========
  const dispatch = useDispatch();
  const openBackendModal = useSelector((state) => state.site.openBackendModal);
  const backendPopupData = useSelector((state) => state.site.backendPopupData);

  // ============handler==============
  // handler to close the modal
  const handleCloseBackendPopup = () => {
    dispatch(setOpenBackendModal(false));
  };

  // function to save in localStorage the choice of user for
  //  don't show the modalfor next refresh or display
  function handleDisplayModal(evt) {
    localStorage.setItem('backendPopup', JSON.stringify({
      value: evt.target.checked,
      creation_date: Date.now(),
      expire_date: (Date.now()) + (2629800000),
    }));
  }

  // useEffect to display modal when backendpopupData is display
  // useEffect(() => {
  //   if (backendPopupData.activate === true) {
  //     dispatch(setOpenBackendModal(true));
  //   }
  // }, [backendPopupData]);

  return (
    <Modal
      open={openBackendModal}
      className="backendPopup"
      onClose={handleCloseBackendPopup}
      aria-labelledby="modal-modal-title"
      arial-aria-describedby="modal-modal-description"
      closeAfterTransition
      slots={{ backdrops: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 600,
        },
      }}
    >
      <Fade in={openBackendModal}>
        <Box sx={styleModal}>
          <Typography className="backendPopup--title" />
          <Box>
            <div dangerouslySetInnerHTML={
              { __html: DOMPurify.sanitize(backendPopupData.message) }
            }
            />
            <div className="backendPopup--modal__text--button">
              <div>
                <label htmlFor="cookie--checkbox">
                  <input id="cookie--checkbox" name="cookie--checkbox" type="checkbox" onClick={(evt) => handleDisplayModal(evt)} /> Don't show again
                </label>
              </div>
              <div>
                <button className="backendPopup--modal__text--button__close" type="button" onClick={handleCloseBackendPopup}>Close</button>
              </div>
            </div>
          </Box>
        </Box>
      </Fade>

    </Modal>
  );
}

export default BackendPopup;
